export default {
  推荐好友加入: `โปรแกรมผู้แนะนำ`,
  赢取巴塞罗那VIP之旅:'ลุ้นรับทริป <span class="vipWord">VIP</span> สู่บาร์เซโลนา  ',

  成为EBC推荐官: "โอกาสนี้เหมาะที่สุด ในการชวนเพื่อนคุณมาร่วมเป็นส่วนหนึ่งกับ EBC Financial Group พร้อมกับสัมผัสประสบการณ์เทรดที่ไม่เหมือนใคร",
  立即参与: "แนะนำทันที",
  专属奖励等你拿: "รางวัลสุดพิเศษ",
  您将获得以下奖励:'แนะนำเพื่อนสำเร็จ 66 คน ก่อนวันที่ 23 พ.ค. 2025 รับรางวัลดังต่อไปนี้',
  西班牙巴塞罗那之旅:'ทริปสุดหรูไปบาร์เซโลนา ประเทศสเปน แบบไม่มีค่าใช้จ่าย',
  巴塞罗那足球俱乐部主场比赛VIP门票:'บัตร VIP ชมการแข่งขันติดขอบสนาม FC Barcelona',
  巴塞罗那足球俱乐部专属晚宴:'เข้าร่วมงานกาลาดินเนอร์สุดเอ็กซ์คลูซีฟของ FC Barcelona',
  往返机票酒店住宿当地接送导服务:'รวม ตั๋วเครื่องบินไป-กลับ ที่พักโรงแรม และทัวร์เที่ยวภาคพื้นดิน',
   如何赢取大奖:'วิธีคว้ารางวัล?',
  登录EBC用户中心: "เข้าสู่ระบบที่ศูนย์ผู้ใช้งาน EBC",
  "进入“大赛推荐官”活动页面": 'ไปที่กิจกรรม “โปรแกรมผู้แนะนำ',
  生成您的邀请链接或二维码: "สร้างลิงก์แนะนำ หรือแชร์  QR โค้ดให้เพื่อนคุณ",
  成功推荐66人: "แนะนำเพื่อนครบ 66 คน",
成功推荐奖励:'เพื่อนที่ได้รับการแนะนำ ต้องฝากเงินอย่างต่ำ $500 และทำการเทรดอย่างน้อย 1 ครั้ง ภายในระยะเวลาที่กำหนด จึงจะถือว่าการแนะนำสำเร็จ',
  你还在等什么:'แล้วคุณจะรออะไร?',
  EBC为交易者捉供更低点差:'EBC มอบสเปรดที่ต่ำกว่า พร้อมรับประกันค่าคอมมิชชั่นคืนที่แข่งขันได้ และสิทธิประโยชน์พิเศษอีกมากมายสำหรับนักเทรดหวังว่าจะได้พบ “คุณ” ที่บาร์เซโลนา',
  每一次推荐: "ทุกการแนะนำ คือโอกาสสู่บาร์เซโลนา",
  参与规则: "เงื่อนไขกิจกรรม:",
  成为EBC推荐官并邀请66人: "เข้าร่วมโปรแกรมผู้แนะนำ EBC ชวนเพื่อนครบ 66 คน",
  所有被邀请人均入金大于等于$500: `โดยแต่ละคนที่คุณแนะนำต้องฝากเงินอย่างน้อย $500 และทำการเทรด 1 ครั้ง`,
  参与方法: "ขั้นตอนเข้าร่วมกิจกรรม:",
  立即推荐: "เริ่มแนะนำตอนนี้ แล้วฉลองแชมป์ไปด้วยกัน",
  
  巴萨荣耀之旅: "เส้นทางแชมป์สู่ FC Barcelona",
  每笔订单都是攻守博弈的艺术: `เกมรุกที่เฉียบคม แนวรับที่แข็งแกร่ง คือ กุญแจสู่ชัยชนะ`,
  活动时间: "ระยะเวลากิจกรรม:",
  "2025年2月22日": "22 ก.พ. 2025 เวลา 01:00:00 ถึง 23 พ.ค. 2025 เวลา 23:59:59 (เวลาตาม MT4/MT5)",
  活动规则: "เงื่อนไขกิจกรรม",
  ruleList: [
    "กิจกรรมเชิญเพื่อน 66 คน ไม่ขัดแย้งกับรางวัลจากโปรแกรมผู้แนะนำและกิจกรรมอื่น ๆ",
    "ผู้ถูกเชิญต้องทำการฝากเงินและเทรดตามเงื่อนไข และการโอนเงินผ่านบุคคลที่สามจะถือว่าผิดเงื่อนไข",
    "ผู้เข้าร่วมกิจกรรมที่ปฏิบัติตามเงื่อนไขเท่านั้นถึงมีสิทธิ์รับเงินรางวัล EBC สามารถยกเลิกสิทธิ์มอบรางวัล สำหรับผู้ที่ฝ่าฝืนเงื่อนไข",
    "บัญชีที่ลงทะเบียนผ่านลิงก์แนะนำไม่ได้รับอนุญาตให้โอนตัวแทน",
    "รางวัลขึ้นอยู่กับการเปิดใช้งานบัญชีอย่างถูกต้อง และตั๋วชมการแข่งขันแบบ VIP รวมค่าเครื่องบินและที่พักเรียบร้อยแล้ว",
    "EBC Financial Group มีสิทธิ์ในการตีความและตัดสิน ทุกกรณีที่เกี่ยวข้องกับกิจกรรมนี้",
  ],
};
